export default __webpack_public_path__ + "static/media/javier.953bcc95.png";